/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Switch, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  minWidth: 100,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

function TaxPersonalTable({ setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      tbCheckbox1: false,
      tbCheckbox2: false,
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: "",
      value18: "",
      value19: "",
      value20: "",
    },
  ]);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      tbCheckbox1: false,
      tbCheckbox2: false,
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: "",
      value18: "",
      value19: "",
      value20: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleChangeValue = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">I. Người phụ thuộc đăng ký thuế bằng CMND/CCCD/Hộ chiếu</Typography>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", fontWeight: "bold", minWidth: 0 }}
              >
                STT
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Họ và tên người phụ thuộc
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                MST (ghi trong trường hợp thay đổi thông tin)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Ngày sinh
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Quốc tịch
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Người Việt Nam (sống ở nước ngoài)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                CMND kê khai sai
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Loại giấy tờ (CMND/CCCD/Hộ chiếu)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Số
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Ngày cấp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Nơi cấp
              </Td>
              <Td colSpan={4} style={{ textAlign: "center", fontWeight: "bold" }}>
                Địa chỉ nơi thường trú
              </Td>
              <Td colSpan={4} style={{ textAlign: "center", fontWeight: "bold" }}>
                Địa chỉ hiện tại
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Quan hệ với cá nhân có thu nhập được giảm trừ gia cảnh
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Tên cá nhân có thu nhập
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Mã số thuế của cá nhân có thu nhập
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Tỉnh, thành phố</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Quận, huyện</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Xã, phường</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Số nhà/ đường phố</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Tỉnh, thành phố</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Quận, huyện</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Xã, phường</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Số nhà/ đường phố</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold", minWidth: 0 }}>(1)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(2)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(3)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(4)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(5)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(6)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(7)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(8)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(9)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(13)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(12)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(11)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(10)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(17)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(16)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(15)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(14)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(18)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(19)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(20)</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  className="toggle-button"
                  style={{ textAlign: "center", fontWeight: "bold", minWidth: 0 }}
                >
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value2"
                    value={item.value2}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value3"
                    type="text"
                    value={item.value3}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="value4"
                    onChange={(e) => handleChangeValue(item.id, "value4", e[0])}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value5", e[0])}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <Switch
                    size="medium"
                    name="tbCheckbox1"
                    onChange={(e) => handleChangeValue(item.id, "tbCheckbox1", e.target.checked)}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <Switch
                    size="medium"
                    name="tbCheckbox2"
                    onChange={(e) => handleChangeValue(item.id, "tbCheckbox2", e.target.checked)}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value6", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value7"
                    id={item.id}
                    value={item.value7}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="value8"
                    onChange={(e) => handleChangeValue(item.id, "value8", e[0])}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value9", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value13", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value12", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value11", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value10"
                    type="text"
                    value={item.value10}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value17", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value16", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value15", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value14"
                    type="text"
                    value={item.value14}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue(item.id, "value18", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value19"
                    type="text"
                    value={item.value19}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value20"
                    type="text"
                    value={item.value20}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable);

function InputTable(props) {
  const { onChange, type = "text", name, id, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id });
    }
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.2rem 0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
